export default [
  {
    srno: "1",
    // title: "Sumit Jaiswal ",
    name: "Sumit",
    description: "Jaiswal",
    imgurl: "1234	",
    tags: "Student	"
  },
  
];
